import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/default-page-layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`thanks to`}</h1>
    <ul>
      <li parentName="ul"><a className="external" href="https://amogh.sh/">amogh</a> for reading multiple drafts and listening to me stress, ideate, and just generally talk really quickly over facetime</li>
      <li parentName="ul">{`my roommate `}<a className="external" href="https://jessding.github.io">{`jess`}</a>{` for helping me come up with this idea at 1am a few weeks ago`}</li>
      <li parentName="ul">{`rebecca and `}<a className="external" href="https://tmb.sh/">{`theo`}</a>{` for reading drafts`}</li>
      <li parentName="ul">{`professor `}<a className="external" href="https://nickm.com/">{`nick montfort`}</a>{` for helpful feedback and thought-provoking questions, and for assigning this project!`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      